import { ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Spin,
  Divider,
  DatePicker,
  Form,
  Radio,
} from "antd";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { Component } from "react";
import { connect } from "react-redux";
import "../Common.global.css";
import locale from "../../constants/locale.json";
const { confirm } = Modal;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      selectedVehicleType: null,
      cards: [],
      newCardModalVisible: false,
      isLoading: false,
      isAddModalMode: false,
      cardLabel: null,
      uid: null,
      firstName: null,
      lastName: null,
      shop: null,
      position: null,
      phoneNumber: null,
      licenseNumber: null,
      memo: null,
      startDate: null,
      expireDate: null,
      isAntipassback: true,
      isApplyRate: false,
      cardId: null,
      cardTypes: [],
      gateGroups: [],
      selectedGateGroupIds: [],
      cardGateGroupMapping: [],
    };
  }

  componentDidMount() {
    return this.refreshList();
  }

  handleCardDetect = (uid) => {
    this.setState({
      uid,
    });
  };

  refreshList = () => {
    this.setState({
      selectedRowKeys: [],
      selectedRows: [],
      isLoading: true,
    });
    return fetch(`/api/v1/card/list`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { cards, gateGroups, cardGateGroupMapping, cardTypes } = data;
        this.setState({
          cards,
          gateGroups,
          cardGateGroupMapping,
          cardTypes,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  onDeleteClick = () => {
    const { selectedRowKeys, isLoading } = this.state;
    const requestData = {
      id: selectedRowKeys[0],
    };
    const _this = this;
    confirm({
      title: "Please confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you would like to delete the selected card?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      okButtonProps: {
        disabled: isLoading,
      },
      onOk() {
        return fetch(`/api/v1/card/delete`, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            token: _this.props.accessToken,
          },
          body: JSON.stringify(requestData),
        })
          .then((res) => {
            if (!res.ok) throw new Error(res.statusText);
            return res.json();
          })
          .then(() => {
            message.success("Delete Completed!");
            _this.setState({ selectedRowKeys: [] });
            _this.refreshList();
          })
          .catch((err) => {
            message.error(
              err instanceof Error ? err.message : "Server cannot be reached"
            );
          });
      },
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  onCreateCardCancel = () => {
    this.setState({
      newCardModalVisible: false,
      cardLabel: null,
      uid: null,
    });
  };

  onCreateCardOk = () => {
    const {
      isAddModalMode,
      cardLabel,
      uid,
      firstName,
      lastName,
      shop,
      position,
      phoneNumber,
      licenseNumber,
      memo,
      isAntipassback,
      isApplyRate,
      selectedCardType,
      startDate,
      expireDate,
      cardId,
      selectedGateGroupIds,
      selectedVehicleType,
    } = this.state;
    this.setState({
      isLoading: true,
    });
    return fetch(`/api/v1/card/${isAddModalMode ? "new" : "update"}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
      body: JSON.stringify({
        id: !isAddModalMode ? cardId : null,
        cardLabel,
        uid,
        firstName,
        lastName,
        shop,
        position,
        phoneNumber,
        licenseNumber,
        memo,
        isAntipassback,
        isApplyRate,
        selectedCardType,
        startDate,
        expireDate,
        selectedGateGroupIds,
        isCar: selectedVehicleType === 1,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(() => {
        this.setState({
          newCardModalVisible: false,
          uid: null,
          personTypeRefCode: null,
        });
        this.refreshList();
        return message.success(
          `Card ${isAddModalMode ? "Created" : "Updated"} Successfully!`
        );
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onAddClick = () => {
    this.setState({
      newCardModalVisible: true,
      isAddModalMode: true,
      selectedVehicleType: null,
      cardLabel: null,
      uid: null,
      firstName: null,
      lastName: null,
      shop: null,
      position: null,
      phoneNumber: null,
      licenseNumber: null,
      memo: null,
      isAntipassback: true,
      isApplyRate: false,
      startDate: null,
      expireDate: null,
      selectedGateGroupIds: [],
      selectedCardType: null,
    });
  };

  onEditClick = () => {
    const { selectedRows, cardGateGroupMapping, cardTypes } = this.state;
    const {
      id,
      uid,
      card_label,
      first_name,
      last_name,
      shop_name,
      position,
      phone_number,
      license_no,
      memo,
      is_car,
      is_antipassback,
      start_date,
      expire_date,
      card_type_id,
    } = selectedRows[0];
    const currentCardType =
      card_type_id && cardTypes.find((ct) => ct.id === card_type_id);
    this.setState({
      isAddModalMode: false,
      newCardModalVisible: true,
      cardId: id,
      cardLabel: card_label,
      uid,
      firstName: first_name,
      lastName: last_name,
      shop: shop_name,
      position: position,
      phoneNumber: phone_number,
      licenseNumber: license_no,
      memo: memo,
      isAntipassback: is_antipassback,
      isApplyRate: currentCardType && currentCardType.is_apply_rate,
      startDate: start_date ? moment(start_date) : null,
      expireDate: expire_date ? moment(expire_date) : null,
      selectedCardType: card_type_id,
      selectedVehicleType: is_car ? 1 : 2,
      selectedGateGroupIds: cardGateGroupMapping
        .filter((cggp) => {
          return cggp.card_id === parseInt(id);
        })
        .map((filteredGateGroups) => filteredGateGroups.gate_group_id),
    });
  };

  onCardNoChange = (e) => {
    this.setState({
      cardLabel: e.target.value,
    });
  };

  onUidChange = (e) => {
    const newValue = e.target.value;
    this.setState({
      uid: newValue.replace(/\D/g, ""),
    });
  };

  onInputFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onFieldChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={``}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text, row) => {
      const { searchedColumn } = this.state;
      if (!text) {
        return <>{"-"}</>;
      }
      return searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      );
    },
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  getCardExport = () => {
    const { accessToken } = this.props;

    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/card/download/xlsx`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({}),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.blob();
      })
      .then((blob) => {
        const filename = moment(new Date()).format("YYYYMMDDHHmmss");
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}_CardList.xlsx`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        message.success("Card List Exported Successfully!");
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const {
      selectedRowKeys,
      cards,
      newCardModalVisible,
      isLoading,
      isAddModalMode,
      selectedRows,
      cardLabel,
      uid,
      firstName,
      lastName,
      shop,
      position,
      phoneNumber,
      licenseNumber,
      memo,
      isAntipassback,
      startDate,
      expireDate,
      gateGroups,
      selectedGateGroupIds,
      selectedCardType,
      selectedVehicleType,
      isExportModalVisible,
      exportType,
      cardTypes,
      isApplyRate,
    } = this.state;
    const rowSelection = {
      type: "radio",
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const { currentLang } = this.props;

    const columns = [
      {
        title: "Vehicle",
        dataIndex: "is_car",
        ellipsis: true,
        align: "center",
        render: (is_car) => {
          return <>{is_car ? "Car" : "Moto"}</>;
        },
      },
      {
        title: "Card Label",
        dataIndex: "card_label",
        ellipsis: true,
        align: "center",
        sorter: (a, b) =>
          (a.card_label || "").localeCompare(b.card_label || ""),
        ...this.getColumnSearchProps("card_label"),
      },
      {
        title: "Card Type",
        dataIndex: "card_type_display_name",
        ellipsis: true,
        align: "center",
        sorter: (a, b) =>
          (a.card_type_display_name || "").localeCompare(
            b.card_type_display_name || ""
          ),
        ...this.getColumnSearchProps("card_type_display_name"),
      },
      {
        title: "Card UID",
        dataIndex: "uid",
        align: "center",
        sorter: (a, b) => (a.uid || "").localeCompare(b.uid || ""),
        ...this.getColumnSearchProps("uid"),
      },
      {
        title: "First Name",
        dataIndex: "first_name",
        ellipsis: true,
        align: "center",
        sorter: (a, b) =>
          (a.first_name || "").localeCompare(b.first_name || ""),
        ...this.getColumnSearchProps("first_name"),
      },
      {
        title: "Last Name",
        dataIndex: "last_name",
        ellipsis: true,
        align: "center",
        sorter: (a, b) => (a.last_name || "").localeCompare(b.last_name || ""),
        ...this.getColumnSearchProps("last_name"),
      },
      {
        title: "Shop",
        dataIndex: "shop_name",
        ellipsis: true,
        align: "center",
        sorter: (a, b) => (a.shop_name || "").localeCompare(b.shop_name || ""),
        ...this.getColumnSearchProps("shop_name"),
      },
      {
        title: "Position",
        dataIndex: "position",
        ellipsis: true,
        align: "center",
        sorter: (a, b) => (a.position || "").localeCompare(b.position || ""),
        ...this.getColumnSearchProps("position"),
      },
      {
        title: "License No.",
        dataIndex: "license_no",
        ellipsis: true,
        align: "center",
        sorter: (a, b) =>
          (a.license_no || "").localeCompare(b.license_no || ""),
        ...this.getColumnSearchProps("license_no"),
      },
      {
        title: "Phone No.",
        dataIndex: "phone_number",
        ellipsis: true,
        align: "center",
        sorter: (a, b) =>
          (a.phone_number || "").localeCompare(b.phone_number || ""),
        ...this.getColumnSearchProps("phone_number"),
      },
      {
        title: "Antipassback",
        dataIndex: "is_antipassback",
        align: "center",
        render: (is_antipassback, row) => {
          // eslint-disable-next-line
          const color = is_antipassback ? "green" : "red";
          const displayName = is_antipassback ? "Yes" : "No";

          return <Tag color={color}>{displayName}</Tag>;
        },
        sorter: (a, b) => {
          return a === b ? 0 : a ? -1 : 1;
        },
      },
      {
        title: "Start Date",
        dataIndex: "start_date",
        align: "center",
        render: (_, row) => {
          return <>{row.start_date_fmt}</>;
        },
        sorter: (a, b) =>
          (a.start_date || "").localeCompare(b.start_date || ""),
      },
      {
        title: "Expire Date",
        dataIndex: "expire_date",
        align: "center",
        render: (_, row) => {
          return <>{row.expire_date_fmt}</>;
        },
        sorter: (a, b) =>
          (a.expire_date || "").localeCompare(b.expire_date || ""),
      },
      {
        title: "Date Updated",
        dataIndex: "updated_at",
        align: "center",
        ellipsis: true,
        render: (updated_at) => {
          return <>{moment(updated_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      },
      {
        title: "Date Created",
        dataIndex: "inserted_at",
        align: "center",
        ellipsis: true,
        render: (inserted_at) => {
          return <>{moment(inserted_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
      },
    ];

    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">
              {locale.app.feature.card.title[currentLang]}
            </div>
            <div className="page-header-sub">
              {locale.app.feature.registration.title[currentLang]}
            </div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <div className="setting-section-search">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    className="setting-detail-group"
                    style={{ padding: "0px" }}
                  >
                    <Button
                      key="Add"
                      className="setting-section-search-btn"
                      type="primary"
                      onClick={this.onAddClick}
                    >
                      Add
                    </Button>
                    <Button
                      key="Edit"
                      className="setting-section-search-btn"
                      onClick={this.onEditClick}
                      disabled={selectedRowKeys.length === 0}
                    >
                      Edit
                    </Button>
                    <Button
                      key="Delete"
                      className="setting-section-search-btn"
                      danger
                      onClick={this.onDeleteClick}
                      disabled={
                        selectedRowKeys.length === 0 ||
                        selectedRows[0].card_status === 2
                      }
                    >
                      Delete
                    </Button>
                    <Button
                      className="setting-section-search-btn"
                      disabled={cards.length === 0}
                      onClick={() => {
                        this.getCardExport();
                      }}
                    >
                      Export
                    </Button>
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className="table-section-header">Cards</div>
              <Table
                rowKey={"id"}
                style={{ overflow: "auto", width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={cards}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
            <Modal
              title={`${isAddModalMode ? "Add" : "Edit"} Card`}
              closable={false}
              visible={newCardModalVisible}
              onOk={this.onCreateCardOk}
              onCancel={this.onCreateCardCancel}
              okButtonProps={{
                disabled:
                  !uid ||
                  !firstName ||
                  !lastName ||
                  isLoading ||
                  !selectedCardType,
              }}
              cancelButtonProps={{ disabled: isLoading }}
            >
              <Col span={24} className="visitor-detail-group">
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Vehicle Type <span style={{ color: "red" }}>*</span>
                  </span>
                  <Select
                    className="group-addon-input"
                    value={selectedVehicleType}
                    onChange={(val) => {
                      this.setState({
                        selectedVehicleType: val,
                      });
                    }}
                  >
                    <Select.Option key={1} value={1}>
                      {"Car"}
                    </Select.Option>
                    <Select.Option key={2} value={2}>
                      {"Moto"}
                    </Select.Option>
                  </Select>
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Type <span style={{ color: "red" }}>*</span>
                  </span>
                  <Select
                    className="group-addon-input"
                    value={selectedCardType}
                    onChange={(val, data) => {
                      const { isAntipassback } = this.state;
                      const { is_apply_rate } = data;
                      this.setState({
                        isAntipassback: is_apply_rate ? true : isAntipassback,
                        isApplyRate: is_apply_rate,
                        selectedCardType: val,
                      });
                    }}
                  >
                    {cardTypes.map((ct) => (
                      <Select.Option
                        value={ct.id}
                        key={ct.id}
                        is_apply_rate={ct.is_apply_rate}
                      >
                        {ct.display_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Label
                  </span>
                  <Input value={cardLabel} onChange={this.onCardNoChange} />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card UID <span style={{ color: "red" }}>*</span>
                  </span>
                  <Input
                    value={uid}
                    type="number"
                    onChange={this.onUidChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Access <span style={{ color: "red" }}></span>
                  </span>
                  <Select
                    mode="multiple"
                    maxTagCount={1}
                    className="group-addon-input"
                    value={selectedGateGroupIds}
                    onChange={(val) =>
                      this.setState({ selectedGateGroupIds: val })
                    }
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {gateGroups.map((ggp) => (
                      <Select.Option value={ggp.id} key={ggp.id}>
                        {ggp.display_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Antipassback <span style={{ color: "red" }}>*</span>
                  </span>
                  <Select
                    className="group-addon-input"
                    value={isAntipassback}
                    disabled={isApplyRate}
                    onChange={(val) => {
                      this.setState({
                        isAntipassback: val,
                      });
                    }}
                  >
                    <Select.Option value={true} key={1}>
                      Yes
                    </Select.Option>
                    <Select.Option value={false} key={2}>
                      No
                    </Select.Option>
                  </Select>
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Start Date
                  </span>
                  <DatePicker
                    style={{ width: "100%" }}
                    showToday={false}
                    placeholder=" "
                    format="DD/MM/YYYY"
                    value={startDate}
                    onChange={(evt) => {
                      let newExpireDate =
                        expireDate < evt ? undefined : expireDate;
                      this.setState({
                        startDate: evt,
                        expireDate: newExpireDate,
                      });
                    }}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Card Expiry Date
                  </span>
                  <DatePicker
                    style={{ width: "100%" }}
                    showToday={false}
                    placeholder=" "
                    format="DD/MM/YYYY"
                    value={expireDate}
                    onChange={(evt) => {
                      let newStartDate =
                        startDate > evt ? undefined : startDate;
                      this.setState({
                        startDate: newStartDate,
                        expireDate: evt,
                      });
                    }}
                  />
                </Input.Group>
                <Divider />
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    First Name <span style={{ color: "red" }}>*</span>
                  </span>
                  <Input
                    name="firstName"
                    value={firstName}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Last Name <span style={{ color: "red" }}>*</span>
                  </span>
                  <Input
                    name="lastName"
                    value={lastName}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Shop
                  </span>
                  <Input
                    name="shop"
                    value={shop}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Position
                  </span>
                  <Input
                    name="position"
                    value={position}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Phone Number
                  </span>
                  <Input
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    License Number
                  </span>
                  <Input
                    name="licenseNumber"
                    value={licenseNumber}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
                <Input.Group
                  compact
                  className="group-compact-select-wrapper"
                  style={{ marginBottom: "10px" }}
                >
                  <span className="ant-input-group-addon group-addon-label">
                    Memo
                  </span>
                  <Input
                    name="memo"
                    value={memo}
                    onChange={this.onInputFieldChange}
                  />
                </Input.Group>
              </Col>
            </Modal>
          </Spin>
        </Card>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    accessToken: auth.token.accessToken,
  };
}

export default connect(mapStateToProps, null)(Registration);
